// Estados de la captura de selfie de la ceremonia de firma (TD-15978). La secuencia normal es:
// camara apagada hasta que el socio pulsa "Activar camara", permiso pendiente, directo y fotograma
// congelado; `denied` es la rama de rechazo de `getUserMedia` (permiso denegado, sin camara,
// camara ocupada o contexto no seguro: el navegador no distingue nada de eso en la UI).
export enum SelfieCameraState {
    permission = 1,
    streaming = 2,
    captured = 3,
    denied = 4,
    inactive = 5
}

// El boton flotante de la caja de foto es el mismo en todos los estados que lo pintan: solo cambian
// texto, icono y accion. En `denied` vuelve a pedir la camara: la ocupada por otra aplicacion o el
// permiso concedido a posteriori desde la barra de direcciones se resuelven sin recargar la pagina.
const SELFIE_CAMERA_STATE_ACTION_TRANSLATION_KEYS: Record<SelfieCameraState, string> = {
    [SelfieCameraState.permission]: '',
    [SelfieCameraState.streaming]: 'selfie_take_photo',
    [SelfieCameraState.captured]: 'selfie_repeat_photo',
    [SelfieCameraState.denied]: 'selfie_activate_camera',
    [SelfieCameraState.inactive]: 'selfie_activate_camera'
};

const SELFIE_CAMERA_STATE_ACTION_ICONS: Record<SelfieCameraState, string> = {
    [SelfieCameraState.permission]: '',
    [SelfieCameraState.streaming]: 'camera',
    [SelfieCameraState.captured]: 'redo',
    [SelfieCameraState.denied]: 'camera',
    [SelfieCameraState.inactive]: 'camera'
};

// El <video> vive siempre en el DOM, pero solo se ve cuando hay algo que ensenar: apagada, en permiso
// y en denegado la caja tiene que dejar ver la silueta de placeholder que dibuja el diseno.
const SELFIE_CAMERA_STATE_STREAM_VISIBILITY: Record<SelfieCameraState, boolean> = {
    [SelfieCameraState.permission]: false,
    [SelfieCameraState.streaming]: true,
    [SelfieCameraState.captured]: true,
    [SelfieCameraState.denied]: false,
    [SelfieCameraState.inactive]: false
};

export function isSelfieCameraStreamVisible(state: SelfieCameraState): boolean {
    return SELFIE_CAMERA_STATE_STREAM_VISIBILITY[state] ?? false;
}

export function getSelfieCameraStateActionText(state: SelfieCameraState): string {
    return SELFIE_CAMERA_STATE_ACTION_TRANSLATION_KEYS[state] ?? '';
}

export function getSelfieCameraStateActionIcon(state: SelfieCameraState): string {
    return SELFIE_CAMERA_STATE_ACTION_ICONS[state] ?? '';
}
